import { render } from "./FrontDetailView.vue?vue&type=template&id=5219d9a8"
import script from "./FrontDetailView.vue?vue&type=script&lang=js"
export * from "./FrontDetailView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marco/Documents/visivalab/vueprojects/rembrandt-touch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__